import React from 'react';
import * as yup from 'yup';
import { RichText } from '../RichText';
import { nullableImageFromCMSSchema } from '../schemas';
import { schema as videoModalSchema } from './video_modal';
import { schema as modalSchema } from './cms_modal';

export const schema = yup
  .object({
    message: yup.mixed().nullable(),
    icon: nullableImageFromCMSSchema,
    iconAlignment: yup.string().nullable(),
    linkText: yup.string().nullable(),
    linkTarget: yup.string().nullable(),
    triggerModal: yup.boolean(),
    modal: yup.lazy(item => {
      if (item?.component === 'video_modal') return videoModalSchema;
      return modalSchema;
    }),
    linkStyle: yup.string().nullable(),
  })
  .transform(value => ({
    message: value.message ? <RichText content={value.message} inline /> : null,
    icon: value.icon || null,
    iconAlignment: value.icon_alignment || undefined,
    linkText: value.link_text || null,
    linkTarget: value.link_target
      ? (value.link_target.cached_url || value.link_target.url) +
        (value.link_target.anchor ? `#${value.link_target.anchor}` : '')
      : null,
    triggerModal: value.trigger_modal || false,
    modal: value.modal?.[0] || null,
    linkStyle: value.link_style || undefined,
  }));
